module.exports = __webpack_public_path__ + "img/lock-img.png";